import { REMOVE_PATHS } from '../../../helpers/api/apiPaths';
import { remove } from '../../../helpers/api/remove';

const replacer = (tpl, data) => tpl.replace(/{([^)]+)?}/g, ($1, $2) => data[$2]);

const API_REMOVE = 'API_REMOVE';
const loadData = (store, next, resourceAction, id) => {
  next({ type: `${resourceAction}_LOADING`, id });

  return remove(replacer(REMOVE_PATHS[resourceAction], { id }))
    .then(
      () => store.dispatch({ type: `${resourceAction}_SUCCESS`, id }),
      () => store.dispatch({ type: `${resourceAction}_FAILED`, id }),
    );
};

export default store => next =>
  action =>
    ((action.resourceAction && action.resourceAction.startsWith(API_REMOVE) && action.id)
      ? loadData(store, next, action.resourceAction, action.id)
      : next(action));



// WEBPACK FOOTER //
// ./src/reducers/middleware/resourceRemover/resourceRemover.middleware.js